// Presets — one-click snippets for the custom-code section.
// Each preset patches { html, css, js } fields on the section.
export const CODE_PRESETS = [
  {
    id: "calendly",
    label: "Calendly booking",
    tag: "widget",
    patch: {
      html: '<!-- Replace YOUR_HANDLE with your Calendly URL slug -->\n<div class="calendly-inline-widget" data-url="https://calendly.com/YOUR_HANDLE?hide_gdpr_banner=1" style="min-width:320px;height:700px"></div>\n<script src="https://assets.calendly.com/assets/external/widget.js" async></script>',
      css: ".calendly-inline-widget iframe { border-radius: 12px }",
      js: "// Calendly loads itself — nothing to do here.",
      height: 720,
    },
  },
  {
    id: "typeform",
    label: "Typeform embed",
    tag: "form",
    patch: {
      html: '<!-- Replace YOUR_ID with your Typeform id -->\n<div data-tf-live="YOUR_ID" style="width:100%;height:560px"></div>\n<script src="//embed.typeform.com/next/embed.js"></script>',
      css: "",
      js: "",
      height: 580,
    },
  },
  {
    id: "google-analytics",
    label: "Google Analytics 4",
    tag: "tracking",
    patch: {
      html: '<div style="display:none">Google Analytics tag loaded (this section is invisible on the live page).</div>',
      css: "",
      js: "// Replace G-XXXXXXX with your GA4 Measurement ID\nvar s=document.createElement('script');\ns.async=true;s.src='https://www.googletagmanager.com/gtag/js?id=G-XXXXXXX';\ndocument.head.appendChild(s);\nwindow.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}\ngtag('js', new Date());\ngtag('config', 'G-XXXXXXX');",
      height: 60,
    },
  },
  {
    id: "facebook-pixel",
    label: "Meta / Facebook Pixel",
    tag: "tracking",
    patch: {
      html: '<div style="display:none">Meta Pixel loaded (invisible on the live page).</div>',
      css: "",
      js: "// Replace YOUR_PIXEL_ID with your Meta Pixel id\n!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');\nfbq('init', 'YOUR_PIXEL_ID');\nfbq('track', 'PageView');",
      height: 60,
    },
  },
  {
    id: "countdown",
    label: "Live countdown timer",
    tag: "widget",
    patch: {
      html: '<div class="cd-wrap">\n  <div class="cd-title">Doors close in</div>\n  <div class="cd-clock" id="cd"><span data-u="d">00</span>d <span data-u="h">00</span>h <span data-u="m">00</span>m <span data-u="s">00</span>s</div>\n</div>',
      css: ".cd-wrap{text-align:center;padding:40px 20px;background:linear-gradient(135deg,#0B5CFF,#7C3AED);color:#fff;font-family:'Manrope',sans-serif}\n.cd-title{font-size:14px;letter-spacing:.2em;text-transform:uppercase;opacity:.85;margin-bottom:14px}\n.cd-clock{font-size:56px;font-weight:900;letter-spacing:.05em}\n@media(max-width:640px){.cd-clock{font-size:36px}}",
      js: "// Set target date here (ISO string):\nvar target=new Date(Date.now()+2*24*60*60*1000).getTime();\nvar el=document.getElementById('cd');\nfunction pad(n){return String(n).padStart(2,'0')}\nfunction tick(){\n  var t=target-Date.now();\n  if(t<0){el.textContent='00d 00h 00m 00s';return}\n  var d=Math.floor(t/86400000);\n  var h=Math.floor(t%86400000/3600000);\n  var m=Math.floor(t%3600000/60000);\n  var s=Math.floor(t%60000/1000);\n  el.querySelector('[data-u=\"d\"]').textContent=pad(d);\n  el.querySelector('[data-u=\"h\"]').textContent=pad(h);\n  el.querySelector('[data-u=\"m\"]').textContent=pad(m);\n  el.querySelector('[data-u=\"s\"]').textContent=pad(s);\n}\ntick(); setInterval(tick,1000);",
      height: 220,
    },
  },
  {
    id: "youtube-hero",
    label: "YouTube background hero",
    tag: "layout",
    patch: {
      html: '<section class="hero">\n  <div class="veil"></div>\n  <iframe class="bg" src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1&mute=1&loop=1&playlist=dQw4w9WgXcQ&controls=0&modestbranding=1" allow="autoplay" frameborder="0"></iframe>\n  <div class="text">\n    <h1>Big bold headline</h1>\n    <p>Subheadline that captures attention.</p>\n    <a class="cta" href="#">Get started →</a>\n  </div>\n</section>',
      css: ".hero{position:relative;height:520px;overflow:hidden;color:#fff;font-family:'Manrope',sans-serif}\n.hero .bg{position:absolute;inset:-30%;width:160%;height:160%;pointer-events:none}\n.hero .veil{position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,.35),rgba(0,0,0,.75))}\n.hero .text{position:relative;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;padding:0 20px}\n.hero h1{font-size:64px;font-weight:900;margin:0 0 12px;letter-spacing:-.02em}\n.hero p{font-size:20px;opacity:.9;max-width:560px;margin:0 0 24px}\n.hero .cta{display:inline-block;background:#22D3EE;color:#0B0D17;font-weight:800;padding:14px 28px;border-radius:999px;text-decoration:none}\n@media(max-width:640px){.hero{height:420px}.hero h1{font-size:36px}}",
      js: "",
      height: 520,
    },
  },
];
